// taken from react-intl-redux package
// Project: https://github.com/ratson/react-intl-redux
// Definitions by: Karol Janyst <https://github.com/LKay>
// Definitions: https://github.com/DefinitelyTyped/DefinitelyTyped
// MIT license

import { connect } from "react-redux";
import { IntlProvider as ReactIntlProvider, IntlConfig } from "react-intl";

export interface IntlState {
  locale: string;
  messages: any;
  formats?: any;
}

function defaultSelector(state: { intl: IntlConfig }) {
  const { intl } = state;
  return {
    key: intl.locale,
    ...intl,
  };
}

const mapStateToProps = (state: any) => defaultSelector(state);

export default connect(mapStateToProps)(ReactIntlProvider);
